import { RoomOccupancy } from './room.interface';
import { Rate } from '../../rate/model';

export enum RoomAvailability {
  none = 'None',
  noAvailability = 'NoAvailability',
  noAvailabilityWithFilters = 'NoAvailabilityWithFilters',
  noAvailabilityWithCrossSell = 'NoAvailabilityWithCrossSell',
  noAvailabilityWithSelectedRoom = 'NoAvailabilityWithSelectedRoom',
  noAvailabilityWithRoomInBasket = 'NoAvailabilityWithRoomInBasket',
}

export interface XHRRoomSearchModel {
  filters: any; // todo if needed in future
  paging: any; // todo if needed in future
  rooms: RoomSearchModel[];
  sortOrders: any; // todo if needed in future
  unavailabilityType: RoomAvailability;
}

export interface RoomSearchModel {
  roomId: number;
  productId: string;
  name: string;
  displayType: string;
  availabilityType: string;
  rates: Rate[];
  defaultOccupancy: RoomOccupancy;
  sortOrder: number;
}
